'use client' // Only needed for App Router

import { AllowedFavouriteCollection } from '@/utils/favourites/types'
import { createContext, useContext, ReactNode } from 'react'

type FavouriteContextType = {
  collection: AllowedFavouriteCollection | null
  itemId: string
  /** Content path the favourite is stored under (Supabase rebuild, 2026-08-26).
   * Detail pages can omit it — the button falls back to the current pathname. */
  path?: string
  /** Display title stored with the favourite. */
  title?: string
}

const FavouriteContext = createContext<FavouriteContextType>({
  collection: null,
  itemId: '',
})

export const FavouriteContextProvider = ({
  collection,
  itemId,
  path,
  title,
  children,
}: FavouriteContextType & { children: ReactNode }) => {
  return (
    <FavouriteContext.Provider value={{ collection, itemId, path, title }}>
      {children}
    </FavouriteContext.Provider>
  )
}

export const useFavouriteContext = () => useContext(FavouriteContext)
